import HttpService from "../services/HttpService";

const API_BASE_URL = window.API_URL + "/administrative-fees";

class AdministrativeFeesServiceClass {
  /**
   * Get all administrative fees
   * @returns {Promise<Array>} Array of administrative fees
   */
  async getAllAdministrativeFees() {
    try {
      const response = await HttpService.getAxiosClient().get(
        `${API_BASE_URL}/all`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching administrative fees:", error);
      throw new Error(
        error.response?.data || "Failed to fetch administrative fees"
      );
    }
  }

  /**
   * Get administrative fees for a specific company
   * @param {string} companyId - Company ID
   * @returns {Promise<Array>} Array of administrative fees for the company
   */
  async getAdministrativeFeesForCompany(companyId) {
    try {
      const response = await HttpService.getAxiosClient().get(
        `${API_BASE_URL}/company/${companyId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        `Error fetching administrative fees for company ${companyId}:`,
        error
      );
      throw new Error(
        error.response?.data || "Failed to fetch administrative fees"
      );
    }
  }

  /**
   * Get a single administrative fee by ID
   * @param {number} id - Fee ID
   * @returns {Promise<Object>} Administrative fee object
   */
  async getAdministrativeFeeById(id) {
    try {
      const response = await HttpService.getAxiosClient().get(
        `${API_BASE_URL}/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error fetching administrative fee with ID ${id}:`, error);
      throw new Error(
        error.response?.data || "Failed to fetch administrative fee"
      );
    }
  }
}

export const AdministrativeFeesService = new AdministrativeFeesServiceClass();
